import axios from 'axios'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { onLogout } from './AuthService'

const unauthorizedCode = [401, 403]

const BaseService = axios.create({
    timeout: 60000,
    baseURL: appConfig.apiPrefix,
})

BaseService.interceptors.request.use(
    (config) => {
        const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
        const persistData = deepParseJson(rawPersistData)

        let accessToken = persistData.auth.session.token

        if (!accessToken) {
            const { auth } = store.getState()
            accessToken = auth.session.token
        }

        if (accessToken) {
            config.headers[
                REQUEST_HEADER_AUTH_KEY
            ] = `${TOKEN_TYPE}${accessToken}`
        }
        return config
    },
    (error) => {
        console.log('🚀 ~ error:', error)
        return Promise.reject(error)
    }
)

BaseService.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        console.log('🚀 ~ error:', error)
        const { response } = error

        if (response && unauthorizedCode.includes(response.status)) {
            store.dispatch(onSignOutSuccess())
        }

        return Promise.reject(error)
    }
)

export default BaseService

export const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
})
api.interceptors.request.use(
    async (config) => {
        const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
        const persistData = deepParseJson(rawPersistData)
        let accessToken = persistData.auth.session.token || null
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }

        return config
    },
    (error) => {
        console.error('Error to call API', error)
    }
)
let isRefreshing = false
let refreshTokens = []

api.interceptors.response.use(
    (response) => {
        // console.log("🚀 ~ response:", response)
        return response
    },

    async (error) => {
        console.log('🚀 ~ error:', error)
        const originalRequest = error.config
        const { refreshToken } = localStorage
        const { response } = error

        if (response && unauthorizedCode.includes(response.status)) {
            store.dispatch(onSignOutSuccess())
            // store.dispatch(onLogout())
        }
        return Promise.reject(error)
        if (
            (error.response.status === 401 || error.response.status === 403) &&
            !originalRequest._retry
        ) {
            originalRequest._retry = true
            return Promise.reject(error)
            if (!isRefreshing) {
                isRefreshing = true
                try {
                    const res = await axios.get('/api/refresh', {
                        baseURL: process.env.REACT_APP_DEPLOY_API,
                        headers: { refreshToken },
                    })
                    if (res.status === 200) {
                        localStorage.setItem(
                            'accessToken',
                            res.data.accessToken
                        )
                        api.defaults.headers.common[
                            'Authorization'
                        ] = `Bearer ${res.data.accessToken}`
                        refreshTokens.forEach((cb) => cb(res.data.accessToken))
                        refreshTokens.length = 0
                        originalRequest.headers[
                            'Authorization'
                        ] = `Bearer ${res.data.accessToken}`
                        return api(originalRequest)
                    } else {
                        store.dispatch(onSignOutSuccess())
                    }
                } catch (e) {
                    store.dispatch(onSignOutSuccess())

                    console.error(e)
                } finally {
                    isRefreshing = false
                }
            }

            return new Promise((resolve) => {
                refreshTokens.push((token) => {
                    originalRequest.headers['Authorization'] = `Bearer ${token}`
                    resolve(api(originalRequest))
                })
            })
        }

        return Promise.reject(error)
    }
)
